'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTemplateMaxWidth = exports.getPlaceholderStyles = exports.setDistance = exports.setInputMetrics = exports.setInputAppearance = exports.setGrabCursor = exports.setBorderRadius = exports.percentToVW = exports.toPercent = exports.toPx = exports.uiLayerShadow = exports.uiFocus = exports.setUiTransition = exports.FONT_FAMILIES = exports.setFontStack = exports.setFontSmoothing = exports.setFontSize = undefined;

var _styledComponents = require('styled-components');

var _Color = require('../core/Color');

var _Style = require('../core/Style');

var _tshirtSize = require('./propTypes/tshirtSize');

var _misc = require('HubStyleTokens/misc');

var _sizes = require('HubStyleTokens/sizes');

var _colors = require('HubStyleTokens/colors');

var _theme = require('HubStyleTokens/theme');

var _times = require('HubStyleTokens/times');

var setFontSize = exports.setFontSize = function setFontSize(size) {
  return (0, _styledComponents.css)(['font-size:', ';'], (0, _Style.remCalc)(size));
};

var setFontSmoothing = exports.setFontSmoothing = function setFontSmoothing(smoothing) {
  var computedSmoothing = smoothing || 'antialiased';

  // No `css` wrapper for this mixin, due to a bug in styled-components v3
  return '\n    -webkit-font-smoothing: ' + computedSmoothing + ';\n    -moz-osx-font-smoothing: ' + (computedSmoothing === 'antialiased' ? 'grayscale' : computedSmoothing) + ';\n  ';
};

// note: just a template literal, not using css function
var setFontStack = exports.setFontStack = function setFontStack(family) {
  return '\n  font-family: \'' + family + '\', ' + _misc.FALLBACK_FONT_STACK + ';\n';
};

var FONT_FAMILIES = exports.FONT_FAMILIES = {
  bold: function bold() {
    return '\n        ' + setFontStack(_misc.WEB_FONT_BOLD) + ';\n        font-weight: ' + _misc.WEB_FONT_BOLD_WEIGHT + ';\n      ';
  },
  demibold: function demibold() {
    return '\n        ' + setFontStack(_misc.WEB_FONT_DEMI_BOLD) + ';\n        font-weight: ' + _misc.WEB_FONT_DEMI_BOLD_WEIGHT + ';\n      ';
  },
  medium: function medium() {
    return '\n        ' + setFontStack(_misc.WEB_FONT_MEDIUM) + ';\n        font-weight: ' + _misc.WEB_FONT_MEDIUM_WEIGHT + ';\n      ';
  },
  italic: function italic() {
    return '\n        ' + setFontStack(_misc.WEB_FONT_ITALIC) + ';\n        font-style: italic;\n        font-weight: ' + _misc.WEB_FONT_ITALIC_WEIGHT + ';\n      ';
  },
  default: function _default() {
    return '\n        ' + setFontStack(_misc.WEB_FONT_REGULAR) + ';\n        font-weight: ' + _misc.WEB_FONT_REGULAR_WEIGHT + ';\n      ';
  }
};

var setUiTransition = exports.setUiTransition = function setUiTransition(property, timing) {
  var computedTiming = timing || _times.MICRO_TRANSITION_TIMING;
  var computedProperty = property || 'all';

  return (0, _styledComponents.css)(['transition:', ' ', ' ease-out;'], computedProperty, computedTiming);
};

/**
 * A mixin that simulates focus styling. Needed when the semantic element with the focus is hidden,
 * such as the `<input>` in `UICheckbox`.
 */
var uiFocus = exports.uiFocus = (0, _styledComponents.css)(['box-shadow:', ' ', ',', ' ', ' !important;'], _sizes.FOCUS_RING_SHADOW_SIZES, (0, _Color.rgba)(_colors.FOCUS_RING_BASE, _sizes.FOCUS_RING_SHADOW_ALPHA), _sizes.FOCUS_RING_SHADOW_LAST_SIZES, _colors.FOCUS_RING_BASE);

var uiLayerShadow = exports.uiLayerShadow = function uiLayerShadow() {
  return (0, _styledComponents.css)(['box-shadow:0 ', ' ', ' 0 ', ';'], _sizes.BASE_SHADOW_OFFSET_Y, _sizes.BASE_SHADOW_BLUR_RADIUS, (0, _Color.rgba)(_theme.BASE_SHADOW_COLOR, parseFloat(_sizes.BASE_SHADOW_ALPHA)));
};

var toPx = exports.toPx = function toPx(value) {
  return typeof value === 'number' ? value + 'px' : value;
};

var toPercent = exports.toPercent = function toPercent(value) {
  return value == null ? undefined : value + '%';
};

var percentToVW = exports.percentToVW = function percentToVW(width) {
  if (typeof width !== 'string') return width;
  return width.replace(/(\d+)%/g, '$1vw');
};

var setBorderRadius = exports.setBorderRadius = function setBorderRadius() {
  var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _sizes.BUTTON_RADIUS;
  return (0, _styledComponents.css)(['border-radius:', ';'], toPx(radius));
};

var setGrabCursor = exports.setGrabCursor = function setGrabCursor() {
  var cursor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'grab';
  return (0, _styledComponents.css)(['cursor:move;cursor:', ';'], cursor);
};

var setInputAppearance = exports.setInputAppearance = function setInputAppearance() {
  return (0, _styledComponents.css)(['display:block;height:', ';width:100%;font-size:', ';line-height:22px;text-align:left;vertical-align:', ';color:', ';background-color:', ';border:', ' solid ', ';border-radius:', ';'], _sizes.INPUT_DEFAULT_HEIGHT, _sizes.INPUT_FONT_SIZE, _misc.INPUT_VERTICAL_ALIGNMENT, _theme.FORM_CONTROL_FOREGROUND_COLOR, _theme.FORM_CONTROL_BACKGROUND_COLOR, _sizes.INPUT_BORDER_WIDTH, _theme.FORM_CONTROL_BORDER_COLOR, _sizes.BUTTON_RADIUS);
};

var setInputMetrics = exports.setInputMetrics = function setInputMetrics() {
  var padVertical = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _sizes.BUTTON_DEFAULT_PADDING_Y;
  var padHorizontal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _sizes.BUTTON_DEFAULT_PADDING_X;
  var padRight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : padHorizontal;
  var padBottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : padVertical;
  var responsive = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  return (0, _styledComponents.css)(['padding-bottom:', ';padding-left:', ';padding-right:', ';padding-top:', ';', ';'], toPx(padBottom), toPx(padHorizontal), toPx(padRight), toPx(padVertical), responsive ? (0, _styledComponents.css)(['@media only screen and (max-width:', '){width:100%;}'], _sizes.GRID_BREAKPOINT_SMALL) : null);
};

var DISTANCE_SIZES = {
  flush: 0,
  xs: _sizes.DISTANCE_MEASUREMENT_EXTRA_SMALL,
  sm: _sizes.DISTANCE_MEASUREMENT_SMALL,
  md: _sizes.DISTANCE_MEASUREMENT_MEDIUM,
  lg: _sizes.DISTANCE_MEASUREMENT_LARGE,
  xl: _sizes.DISTANCE_MEASUREMENT_EXTRA_LARGE
};

var setDistance = exports.setDistance = function setDistance() {
  var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'md';

  var size = DISTANCE_SIZES[(0, _tshirtSize.toShorthandSize)(distance)];
  return (0, _styledComponents.css)(['margin-top:', ';margin-bottom:', ';'], size, size);
};

/**
 * Given styles, wraps them in selectors to apply to placeholder text in an input or textarea.
 */
var getPlaceholderStyles = exports.getPlaceholderStyles = function getPlaceholderStyles(styles) {
  return (0, _styledComponents.css)(['&::-moz-placeholder{opacity:1;', ';}&:-ms-input-placeholder{', ';}&::-webkit-input-placeholder{', ';}'], styles, styles, styles);
};

/**
 * @returns a mixin that sets the appropriate width and margins to match a page template with
 * `pageLayout="max-width"`.
 */
var setTemplateMaxWidth = exports.setTemplateMaxWidth = function setTemplateMaxWidth() {
  return (0, _styledComponents.css)(['margin-left:auto;margin-right:auto;max-width:', ';'], toPx(parseInt(_sizes.LAYOUT_MAX_WIDTH, 10) + parseInt(_sizes.LAYOUT_PADDING_X, 10) * 2));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/utils/Styles.js
// module id = 10
// module chunks = 177